const replaceAwithB = (A, B, idx, stockList) => {
  stockList.forEach((obj, index) => {
    if (idx < index) {
      if (JSON.stringify(obj["stock1"]) === JSON.stringify(A)) {
        obj["stock1"] = B;
      }
      if (JSON.stringify(obj["stock2"]) === JSON.stringify(A)) {
        obj["stock2"] = B;
      }
    }
  });
};
const SwitchingStockCards = (stockType, stockList, idx) => {
  if (idx !== stockList.length - 1) {
    if (
      JSON.stringify(stockList[idx + 1]["stock1"]) ===
        JSON.stringify(stockList[idx][stockType]) ||
      JSON.stringify(stockList[idx + 1]["stock2"]) ===
        JSON.stringify(stockList[idx][stockType])
    ) {
      // the stock is on the next page
    } else {
      if (stockType === "stock1") {
        stockList[idx + 1]["stock2"] = stockList[idx + 1]["stock1"];

        stockList[idx + 1]["stock1"] = stockList[idx]["stock1"];

        replaceAwithB(
          stockList[idx]["stock2"],
          stockList[idx]["stock1"],
          idx,
          stockList
        );
      } else {
        if (
          JSON.stringify(stockList[idx + 1]["stock1"]) ===
          JSON.stringify(stockList[idx]["stock1"])
        ) {
          replaceAwithB(
            stockList[idx]["stock1"],
            stockList[idx]["stock2"],
            idx,
            stockList
          );
          stockList[idx + 1]["stock1"] = stockList[idx + 1]["stock2"];
        }
        stockList[idx + 1]["stock2"] = stockList[idx]["stock2"];
      }
    }
  }
  // output(stockType, stockList, idx);
};

export default SwitchingStockCards;
